// Portrait / landscape layouts. Landscape rotates the whole table when the phone is held upright.
export function setupDisplay({ announce = () => {} } = {}) {
  const root = document.documentElement;
  const viewport = document.getElementById('play-viewport');
  const shell = document.getElementById('play-shell');
  const buttons = [...document.querySelectorAll('button[data-display-mode]')];
  const vv = window.visualViewport;
  const table = document.getElementById('table');
  const hand = document.getElementById('hand');
  const melds = document.getElementById('your-melds');
  const KEY = 'speed-mahjong-display';
  let mode = 'portrait';
  let frame = 0;
  try {
    if (window.localStorage.getItem(KEY) === 'landscape') mode = 'landscape';
  } catch {}

  // In landscape, shrink the table until the hand fits on screen.
  function fit() {
    frame = 0;
    root.style.removeProperty('--fitted-table-height');
    if (mode !== 'landscape' || vv?.scale > 1.02) return;
    const box = viewport.getBoundingClientRect();
    const handBox = hand.getBoundingClientRect();
    if (!box.width || !handBox.width) return;
    const rotated = root.classList.contains('rotated-display');
    const meldBox = melds.getBoundingClientRect();
    const lowest = meldBox.height && melds.children.length ? meldBox : handBox;
    const pad = parseFloat(window.getComputedStyle(shell).paddingBottom) || 0;
    const overflow =
      (rotated ? box.left + pad + 12 - Math.min(handBox.left, lowest.left) : Math.max(handBox.bottom, lowest.bottom) - (box.bottom - pad - 12)) + shell.scrollTop;
    const min = parseFloat(window.getComputedStyle(root).getPropertyValue('--minimum-table-height')) || 144;
    if (overflow > 0) root.style.setProperty('--fitted-table-height', `${Math.max(min, Math.floor(table.offsetHeight - overflow))}px`);
  }
  const queueFit = () => {
    frame ||= window.requestAnimationFrame(fit);
  };

  function apply() {
    const unzoomed = vv && (!vv.scale || vv.scale <= 1.02);
    const w = unzoomed && vv.width > 0 ? vv.width : window.innerWidth;
    const h = unzoomed && vv.height > 0 ? vv.height : window.innerHeight;
    const left = (unzoomed && vv.offsetLeft) || 0;
    const top = (unzoomed && vv.offsetTop) || 0;
    const landscape = mode === 'landscape';
    const rotate = landscape && window.innerHeight > window.innerWidth;
    root.classList.toggle('landscape-mode', landscape);
    root.classList.toggle('rotated-display', rotate);
    root.classList.toggle('short-landscape', landscape && (rotate ? w : h) <= 360);
    root.style.setProperty('--play-width', `${rotate ? h : w}px`);
    root.style.setProperty('--play-height', `${rotate ? w : h}px`);
    root.style.setProperty('--viewport-width', `${w}px`);
    root.style.setProperty('--viewport-height', `${h}px`);
    root.style.setProperty('--viewport-left', `${left}px`);
    root.style.setProperty('--viewport-top', `${top}px`);
    root.dataset.screenMode = mode;
    for (const b of buttons) b.setAttribute('aria-pressed', String(b.dataset.displayMode === mode));
    queueFit();
  }

  for (const b of buttons) {
    b.addEventListener('click', () => {
      const next = b.dataset.displayMode;
      if (next === mode) return apply();
      mode = next;
      try {
        window.localStorage.setItem(KEY, mode);
      } catch {}
      apply();
      shell.scrollTop = 0;
      window.scrollTo?.({ top: 0, left: 0, behavior: 'instant' });
      announce(mode === 'landscape' ? 'Switched to landscape. Hold your phone sideways.' : 'Back to portrait.');
    });
  }
  window.addEventListener('resize', apply);
  window.addEventListener('pageshow', apply);
  window.addEventListener('mahjong-view-change', apply);
  vv?.addEventListener('resize', apply);
  vv?.addEventListener('scroll', apply);
  if (window.ResizeObserver) {
    const ro = new window.ResizeObserver(queueFit);
    for (const sel of ['.site-header', '.table-toolbar', '.online-strip', '.hand-topline', '#hand', '#your-melds']) {
      const el = document.querySelector(sel);
      if (el) ro.observe(el);
    }
  }
  apply();
}
